import React, { useContext } from 'react';
import styled from 'styled-components';
import { fontSize, minBreakpointQuery } from '../styles';
import { Svg } from './ui';
import { StoreContext } from '../context/StoreContext';
import gbFlag from '../images/gb-flag.svg';
import euFlag from '../images/eu-flag.svg';

const StyledCurrencySelector = styled.div`
  display: inline-flex;
  align-items: center;

  ${minBreakpointQuery.mlarge`
    display: flex;
    justify-content: center;
  `}

  ${minBreakpointQuery.xlarge`
    display: inline-flex;
  `}
`;

const StyledFlag = styled(Svg)`
  width: 18px;
  height: 18px;
`;

const StyledSelect = styled.select`
  border: none;
  ${fontSize(16)};
`;

const CurrencySelector = () => {
  const { currency, changeCurrency } = useContext(StoreContext);

  const handleChange = e => {
    changeCurrency(e.target.value.toUpperCase());
  };

  const flag = currency === 'GBP' ? gbFlag : euFlag;

  return (
    <StyledCurrencySelector>
      <StyledFlag
        image={flag}
        alt={currency === 'GBP' ? 'GBP Flag British Pound' : 'EUR Flag Euro'}
      />
      <StyledSelect
        name="select-currency"
        id="select-currency"
        value={currency}
        onChange={handleChange}
      >
        <option value="GBP">GBP</option>
        <option value="EUR">EUR</option>
      </StyledSelect>
    </StyledCurrencySelector>
  );
};

export default CurrencySelector;
